import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AgGridModule } from "ag-grid-angular";
import { NgxSpinnerModule } from "ngx-spinner";
import { BadgeModule } from "primeng/badge";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DropdownModule } from "primeng/dropdown";
import { FieldsetModule } from "primeng/fieldset";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ListboxModule } from "primeng/listbox";
import { PanelModule } from "primeng/panel";
import { SplitterModule } from "primeng/splitter";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";
import { AuthGuardService } from "../services/auth-guard.service";
import { GenerateTimesheetComponent } from "./generate-timesheet-form.component";
import { ManageTimesheetComponent } from "./manage-timesheet.component";
import { TimesheetActionComponent } from "./timesheet-action.component";
import { TimesheetFormComponent } from "./timesheet-form.component";
import { TimesheetComponent } from "./timesheet.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    AgGridModule.withComponents([]),

    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    ConfirmDialogModule,
    DropdownModule,
    FieldsetModule,
    InputNumberModule,
    InputTextareaModule,
    InputTextModule,
    ListboxModule,
    PanelModule,
    SplitterModule,
    TableModule,
    ToolbarModule,
    TooltipModule,
    ToastModule,

    RouterModule.forChild([
      { path: 'timesheets', component: TimesheetComponent, canActivate: [AuthGuardService] }
    ])    
  ],
  declarations: [
    ManageTimesheetComponent,
    TimesheetActionComponent,
    TimesheetFormComponent,
    TimesheetComponent,
    GenerateTimesheetComponent
  ]
})
export class TimesheetModule{}